module.exports = __webpack_public_path__ + "img/mx_seguromultidispositivo.2bad8da4.png";